// Where "Help" goes on phones. The right slot of the Figma stack headers (deal
// flow, messages, edit profile, coach profile; MobileShell 1767:709) reads
// "Help"; the web has no help centre, so it opens an email to the address the
// coach profile already uses for "Contact support".

export const SUPPORT_EMAIL = "hello@cachescore.com";

// Pass as `action` to MobileStackHeader. The accessible name starts with the
// visible "Help" (WCAG 2.5.3, label in name), so voice control users can say
// what they see, and then says where it goes.
export const HELP_ACTION = {
  label: "Help",
  href: `mailto:${SUPPORT_EMAIL}`,
  ariaLabel: "Help, email Cache support",
};
